import { createContext, useContext } from 'react'

interface CatalogueCtx {
  hasNav: boolean
}

export const CatalogueContext = createContext<CatalogueCtx>({ hasNav: false })
export const useCatalogueContext = () => useContext(CatalogueContext)
